import { AxiosPromise } from 'axios';
import { http } from 'services';
import * as Types from './types';

/** Returns a short-lived signed B2 URL plus the persisted key; the renderer refreshes it via SignImages. */
export const UploadImage = (
  data: Types.IApi.UploadImage.Request,
): AxiosPromise<Types.IApi.UploadImage.Response> => {
  const form = new FormData();
  form.append('file', data.file);
  if (data.context) form.append('context', data.context);
  return http.request.post('/api/uploads/image', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

/** Called by the renderer when it meets an image with a `data-b2-key` and an expired or absent src. */
export const SignImages = (
  data: Types.IApi.SignImages.Request,
): AxiosPromise<Types.IApi.SignImages.Response> => {
  return http.request.post('/api/uploads/sign', { keys: data.keys });
};
